import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { getUserTeams } from 'actions/User';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HideInPercy from 'components/HideInPercy';
import { faCog, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

import { showModal } from 'actions';

import AppPaths from 'AppPaths';
import Tooltip from 'components/Tooltip';

const StyledUncontrolledDropdown = styled(UncontrolledDropdown)`
  max-width: 100%;
`;

const StyledDropdownToggle = styled(DropdownToggle)`
  padding-left: 0;
  padding-bottom: 0;

  @media only screen and (max-width: 768px) {
    padding-bottom: 0;
    line-height: 13px;
  }
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  font-size: 16px;
  margin-left: 6px;
  transform: translateY(-2px);

  path {
    stroke-width: 30;
    stroke: black;
  }

  @media only screen and (max-width: 768px) {
    font-size: 10px;
  }
`;
const StyledHeader = HideInPercy(styled.h1`
  color: #333333;
  font-size: 28px;
  font-weight: bold;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap !important;
  max-width: 100%;

  @media only screen and (max-width: 768px) {
    line-height: 30px;
  }
`);

const StyledDropdownItem = styled(DropdownItem)`
  max-width: 250px;
`;

const StyledLink = styled(Link)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledDivider = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;
  border-radius: 5px;
  margin: 0.25rem 1rem;
`;

const StyledSettingsIcon = styled(FontAwesomeIcon)`
  display: inline-block;
  margin-right: 8px;
`;

const MyUpcomingEvents = styled.h1`
  padding-top: 10px !important;
  margin-bottom: 6px !important;
  color: #333333;
  font-size: 28px;
  font-weight: bold;
`;

const StyledDropdownMenu = styled(DropdownMenu)`
  max-height: 250px;
  overflow: auto;
`;

const TeamUserDashDropdown = ({
  team,
  teams,
  isTeamAdmin,
  getUserTeams,
  user,
  showModal,
  location
}) => {
  const [previousTitle, setPreviousTitle] = useState('');

  useEffect(() => {
    if (!teams && user) {
      getUserTeams();
    }
  }, [getUserTeams, teams, user]);

  useEffect(() => {
    if (location.pathname === AppPaths.UserDash)
      setPreviousTitle('My upcoming events');
    else {
      if (team) setPreviousTitle(team.title);
    }
  }, [team, location, setPreviousTitle]);

  if (!isTeamAdmin) {
    return <MyUpcomingEvents>My upcoming events</MyUpcomingEvents>;
  }

  if (!teams || !user) {
    return <MyUpcomingEvents>&nbsp;</MyUpcomingEvents>;
  }

  const items = teams.map(t => {
    return (
      <StyledDropdownItem key={`team-dropdown-item-${t._id}`}>
        <StyledLink to={`/dash/team/${t._id}`}>{t.title}</StyledLink>
      </StyledDropdownItem>
    );
  });

  items.push(
    <Fragment key="team-user-drop-all-events-opt">
      <Tooltip
        id="team-user-drop-all-events-opt"
        placement="bottom"
        title="Show all upcoming Events you have access to, including those not part of this Team account"
      />
      <DropdownItem key={`team-dropdown-item-all-events`}>
        <Link
          to="/dash/user"
          data-testid="allEventsDropdownItem"
          aria-describedby="tip-team-user-drop-all-events-opt"
        >
          All my events
        </Link>
      </DropdownItem>
    </Fragment>
  );

  if (location.pathname !== AppPaths.UserDash) {
    items.unshift(<StyledDivider key={`team-dropdown-divider`} />);

    items.unshift(
      <DropdownItem
        key={`team-dropdown-settings`}
        onClick={team => showModal('TEAM_EDIT', team)}
      >
        <StyledSettingsIcon
          icon={faCog}
          data-testid="teamSettingsDropdownItem"
        />
        <span>Team Settings</span>
      </DropdownItem>
    );
  }

  return (
    <StyledUncontrolledDropdown>
      <Tooltip
        visible={isTeamAdmin}
        id="team-user-dash-dropdown"
        title="Switch between Team accounts and modify Team settings"
      />
      <StyledDropdownToggle
        nav
        data-testid="teamUserDashDropdown"
        className="fs-exclude"
        aria-describedby="tip-team-user-dash-dropdown"
      >
        <StyledHeader>
          {previousTitle} <StyledFontAwesomeIcon icon={faChevronDown} />
        </StyledHeader>
      </StyledDropdownToggle>
      <StyledDropdownMenu end>{items}</StyledDropdownMenu>
    </StyledUncontrolledDropdown>
  );
};

export default withRouter(
  connect(
    ({ isTeamAdmin, teams, team, user }) => {
      return { isTeamAdmin, teams, team, user };
    },
    {
      getUserTeams,
      showModal
    }
  )(TeamUserDashDropdown)
);
